import { connect } from 'react-redux'
import { getHeaderSection, getHelpSection } from 'services/explore'
import { applyFilterService, applySearchService } from 'services/ideas'
import { getActiveOrganizations } from 'services/organizations'
import { getActiveTypes } from 'services/types'
import { getUserOrganisations } from 'services/user_profile'
import { getInnovateAllIdeaList } from 'services/innovate/idea'
import { FIRST_LIMIT_CONSTANT } from 'common_constants/Ideas'
import View from './View'

const mapStateToProps = state => ({
  isAdmin: state.data.user.admin,
  isHackathonEnable: state.data.domain.config.globalIsHackthon,
  // Legacy (non-hackathon) list
  domainLoaded: state.data.domain.dataLoaded,
  ideas: state.data.idea.data,
  isIdeasLoading: state.data.idea.ideasLoading,
  totalIdeas: state.data.idea.total,
  itemsIdeas: state.data.idea.items,
  ideasInvested: state.data.user.investments.ideas,
  serviceLineOrgs: state.data.domain.organizations,
  typesStatus: state.data.domain.types,
  useHelpSection: state.data.domain.domainConfiguration.useHelpSection,
  ideaStatusStepper: state.data.domain.domainConfiguration.ideaStatusStepper,
})

const mapDispatchToProps = dispatch => ({
  // Innovate All Ideas: (query, { onSuccess, onFailure }) -> ideaList request (see useInnovateIdeaList)
  fetchInnovateIdeaList: (query, callbacks) => dispatch(getInnovateAllIdeaList({ ...query, ...callbacks })),
  // Legacy (non-hackathon) list
  applyFilter: (challenge, organizations, status, types, ideasLocation, limit = FIRST_LIMIT_CONSTANT, offset) =>
    dispatch(applyFilterService({ challenge, organizations, status, types, ideasLocation, limit, offset })),
  applySearch: search => dispatch(applySearchService({ search })),
  getUserOrganisations: () => dispatch(getUserOrganisations()),
  getHeaderSection: () => dispatch(getHeaderSection()),
  getHelpSection: () => dispatch(getHelpSection()),
  getActiveOrganization: () => dispatch(getActiveOrganizations()),
  getActiveTypes: () => dispatch(getActiveTypes()),
})

export default connect(mapStateToProps, mapDispatchToProps)(View)